import ping from '@databases/ping-registry';

import { PresenceState } from './presence-state';

export const presenceState = new PresenceState(ping);
